export default __webpack_public_path__ + "static/media/todo.d89fd299.svg";